import {
    Divider,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    ListItemSecondaryAction,
    IconButton,
} from '@mui/material';
import { Delete as DeleteIcon, Star } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { formatPriceByLocale, fullName } from '../../lib/utils';

type Enrollment = {
    price: number;
    paymentFormLang?: string;
    status: string;
    priceShape?: {
        currency?: string;
        locale?: string;
    };
};

type Participant = {
    name?: string;
    surname?: string;
    admin?: boolean;
    enrollment?: Enrollment;
};

type Props = {
    participants: Participant[];
    onDelete: (participant: Participant) => void;
};

export function SttParticipantsList({
    participants,
    onDelete,
}: Props): React.ReactElement {
    const { t } = useTranslation();

    // -----| Render |-----
    return (
        <List>
            {participants &&
                participants.map((participant: any, i: any) => {
                    let priceText = '';
                    let paymentForm;
                    let paymentFormClass;
                    if (participant.enrollment) {
                        if (participant.enrollment.price > 0) {
                            priceText = formatPriceByLocale(
                                participant.enrollment.price,
                                participant?.enrollment?.priceShape?.currency,
                                participant?.enrollment?.priceShape?.locale,
                            );
                            paymentForm =
                                participant.enrollment.paymentFormLang;
                        } else {
                            priceText = t('Free');
                        }
                        paymentFormClass =
                            participant.enrollment.status === 'PAID' ? '' : '';
                    }

                    return (
                        <div key={i}>
                            {i > 0 && <Divider />}
                            <ListItemButton>
                                <ListItemText
                                    primary={fullName(participant)}
                                    secondary={`${priceText}${
                                        paymentForm ? ` - ${paymentForm}` : ''
                                    }`}
                                    secondaryTypographyProps={{
                                        className: paymentFormClass,
                                    }}
                                />
                                {!participant.admin ? (
                                    <ListItemSecondaryAction>
                                        <IconButton
                                            onClick={() =>
                                                onDelete(participant)
                                            }
                                            edge="end"
                                            aria-label="delete"
                                        >
                                            <DeleteIcon />
                                        </IconButton>
                                    </ListItemSecondaryAction>
                                ) : (
                                    <Star />
                                )}
                            </ListItemButton>
                        </div>
                    );
                })}
            {participants && participants.length === 0 && (
                <ListItem>
                    <ListItemText primary={t('None')} />
                </ListItem>
            )}
        </List>
    );
}
